import PropTypes from 'prop-types';
import {Toolbar, Typography, Chip, Tooltip} from '@material-ui/core';
import {Build as BuildIcon} from '@material-ui/icons';
import clsx from 'clsx';
import {grey} from '@material-ui/core/colors';
import {useStyles} from 'Utility/styles';

export default function ScheduleLobbyActionToolbar(props) {
  const {numSchedules} = props;
  const classes = useStyles();

  return (
    <Toolbar className={classes.greyToolbar}>
      <Typography className={classes.spacer} variant={'h5'}>
        Schedule Lobby
      </Typography>
      <Chip
        className={clsx(classes.chip, classes.spacer)}
        label={numSchedules}
      />
      <Tooltip title="Work In Progress">
        <BuildIcon style={{marginLeft: 10, color: grey[500]}} />
      </Tooltip>
    </Toolbar>
  );
}

ScheduleLobbyActionToolbar.propTypes = {
  numSchedules: PropTypes.number.isRequired,
};
